"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = void 0;
var sort = function (files) {
    return files.sort(function (a, b) {
        var _a, _b;
        var at = (_a = a.path) !== null && _a !== void 0 ? _a : a.name;
        var bt = (_b = b.path) !== null && _b !== void 0 ? _b : b.name;
        return at.localeCompare(bt, undefined, {
            numeric: true,
            sensitivity: 'base'
        });
    });
};
exports.sort = sort;
